import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import Table, { dateFormatter, buttonsStyle } from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import TableChartIcon from '@material-ui/icons/TableChart';
import { alertError, alertSuccess } from '../../../../utils/logger'
import { deleteDeal, getAllDeals, postDeal, getDealById } from "../../../../api/deal";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { registerLicense } from '@syncfusion/ej2-base';
import { ExcelExport, Workbook } from "@syncfusion/ej2-excel-export";

export default function DealPage() {
    registerLicense("Ngo9BigBOggjHTQxAR8/V1JFaF5cX2JCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZcc3RdQmFZVUByWkBWYEg=");
    // registerLicense("Ngo9BigBOggjHTQxAR8/V1JEaF1cWmhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEBjUH1dcHxQRGFfWEN2XEleYw==");


    const history = useHistory();
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [deal, setDeal] = useState(null);


    useEffect(() => {
        getAllDeals()
            .then((res) => {
                const newData = res.data.map((deal) => ({
                    ...deal,
                    project: deal.project?.title,
                    buyer: deal.buyer.fullName,
                    currentStep: deal?.currentStep ? deal?.currentStep?.charAt(0).toUpperCase() + deal?.currentStep?.slice(1) : "",
                }))
                setData(newData);
                setFilteredData(newData);
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get deals.' })
            })
    }, [refresh]);

    function buttonFormatter(cell) {
        const elem = data.find((item) => item._id === cell);
        return (
            <>
                <Tooltip title="Export NBO">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={async () => {
                        try {
                            const { data } = await getDealById(elem._id);
                            const deal = data;
                            const nbos = Array.isArray(deal?.nbo) ? deal.nbo : deal?.nbo ? [deal.nbo] : [];

                            if (!nbos.length) {
                            alertError({ customMessage: "No NBOs found for this deal." });
                            return;
                            }

                            // Preparamos los datos para Excel
                            const rows = nbos.map((nbo, i) => ({
                            "#": i + 1,
                            "Deal": deal.project?.title ?? "---",
                            "Buyer": deal.buyer?.fullName ?? "---",
                            "Proposed Price (k€/MW)": nbo?.proposedPrice ?? "",
                            "Contingences (%)": nbo?.contingences ?? "",
                            "Exclusivity": nbo?.exclusivity ? "Yes" : "No",
                            "Exclusivity (months)": nbo?.exclusivityMonths ?? "",
                            "Transaction Structure": nbo?.acquiring ?? "",
                            "Percent Acquired (%)": nbo?.percentAc ?? "",
                            "Services Required":
                                Object.entries(nbo?.serv || {})
                                .filter(([_, val]) => val)
                                .map(([key]) => key.toUpperCase())
                                .join(", ") || "",
                            "Observations": nbo?.observations ?? "",
                            }));

                            const workbook = new Workbook({
                            worksheets: [
                                {
                                name: "NBO Comparison",
                                rows: [
                                    {
                                    cells: Object.keys(rows[0]).map((key) => ({
                                        value: key,
                                        style: { bold: true, hAlign: "Center" },
                                    })),
                                    },
                                    ...rows.map((row) => ({
                                    cells: Object.values(row).map((v) => ({ value: v })),
                                    })),
                                ],
                                },
                            ],
                            });

                            workbook.saveAsBlob().then((blob) => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.href = url;
                            a.download = `${deal.project?.title || "deal"}_NBOs.xlsx`;
                            a.click();
                            });
                        } catch (error) {
                            alertError({ error, customMessage: "Could not export NBOs." });
                        }
                        }}
                    >
                        <TableChartIcon />
                    </Button>
                </Tooltip>
                <Tooltip title="Watch">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            history.push("/watch-deal/" + elem._id)
                        }}
                    >
                        <VisibilityIcon />
                    </Button>
                </Tooltip>
                <Tooltip title="Delete">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setDeal(elem);
                            setOpenConfirmDialog(2);
                        }}
                    >
                        <DeleteIcon />
                    </Button>
                </Tooltip>
            </>
        );
    }

    const columns = [
        { dataField: "project", text: "Project name", sort: true },
        { dataField: "buyer", text: "Buyer name", sort: true },
        {
            dataField: "currentStep", text: "Current step", sort: true,
            formatter: (_cell, row) => {
                if (row.status !== "accepted")
                    return row.status.toUpperCase();
                return row.currentStep;
            },
        },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "_id", text: "",
            formatter: (cell, row) => {
                if (row.status !== "accepted") {
                    return null;
                }

                return buttonFormatter(cell);
            },
            headerStyle: { width: '150px' }
        }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Deals list">
                </CardHeader>
                <CardBody>
                    <Table data={filteredData} columns={columns} key={data.length} />
                </CardBody>
            </Card>

            <ConfirmDialog
                title={`Are you sure you want to remove this deal?`}
                open={openConfirmDialog === 2}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteDeal(deal?._id)
                        .then((res) => {
                            alertSuccess({
                                title: "Deleted!",
                                customMessage: `Deal removed successfully.`,
                            });
                            setRefresh(true);
                        })
                        .catch((error) => {
                            alertError({
                                error,
                                customMessage: `Could not remove deal`,
                            });
                        });
                }}
            />
        </>
    );
}